/* global mixpanel */
import formatDate from 'mixpanel/formatDate'

export function reportsShiftsStart ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Shifts Start', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsShiftsChangeFilter ({outletIds, startDate, endDate}) {
  mixpanel.track('Report Shifts Change Filter', {
    'Current Selected Outlet': outletIds,
    'Current Time Filter Start': formatDate(startDate),
    'Current Time Filter End': formatDate(endDate)
  })
}

export function reportsShiftsSelect ({shift}) {
  mixpanel.track('Report Shift Select', {
    'Name': shift.employee_name,
    'Starting Shift': formatDate(shift.created_at),
    'Ending Shift': formatDate(shift.ended_at),
    'Starting Cash': shift.starting_cash,
    'Cash Sales': shift.cash_sales,
    'Cash from Invoice': shift.cash_invoice,
    'Cash Refunds': shift.cash_refund,
    'Total Expense': shift.total_expense,
    'Total Income': shift.total_income,
    'Expected Ending Cash': shift.expected_ending_cash,
    'Actual Ending Cash': shift.actual_ending_cash,
    'Debit Credit': shift.total_debit_credit,
    'Debit Credit Voided': shift.total_voided,
    'Expected Card Payment': shift.expected_card_payment,
    'EDC': shift.total_edc,
    'Gift Card': shift.total_gift_card,
    'Other': shift.total_other,
    'Other Refunds': shift.other_refunds,
    'Expected Other Payment': shift.expected_other_payment,
    'Total Expected': shift.total_expected,
    'Total Actual': shift.total_actual,
    'Difference': shift.total_difference
  })
}



// WEBPACK FOOTER //
// ./app/mixpanel/reports/shifts.js